import React from 'react';

export const CustomFieldTemplate = (props) => {
    const {id, classNames, label, help, required, description, errors, children, displayLabel} = props;
    const calculatedLabelDisplay = displayLabel && label && label !== " ";
    return (
      <div className={classNames}>
        {calculatedLabelDisplay && <label htmlFor={id}>{label}{required ? <span className="text-danger">*</span> : null}</label>}
        {description}
        {children}
        {errors}
        {help}
      </div>
    );
  };